import React from 'react';
import styles from './teammate-selector.module.scss';
// import UserComponent from 'components/userComponent';
import { WorkflowCreationContext } from '../WorkflowCreation2/WorkflowCreation2';
import CustomUserComponent from 'components/CustomUserComponent/CustomUserComponent';
import PerfectScrollbar from 'react-perfect-scrollbar';

const TeammateSelector = (
  {
    data,
    onDataSelected,
    elementContainerClass,
    containerClassName,
    searchString,
    excludes
  }: {
    data: any,
    onDataSelected: any,
    elementContainerClass?: any,
    containerClassName?: any,
    searchString?: any
      excludes?: any
  }
) => {

  const filteredData = data
  const { group, } = React.useContext(WorkflowCreationContext);

  return (
    <PerfectScrollbar
      className={`${styles.contentSelector__container} ${containerClassName ? containerClassName : ''}`}
      options={{ wheelPropagation: false }}
    >

      {
        filteredData.length > 0 ?
          <>
            {filteredData.map((dataElement: any, index: any) => {
              if (excludes && excludes.includes(dataElement.id)) {
                return;
              }
              return (
                <div
                  key={index}
                  className={`${styles.contentSelector__element__container} ${elementContainerClass ? ` ${elementContainerClass}` : ''}`}
                  onClick={() => onDataSelected(dataElement)}
                >
                  <CustomUserComponent
                    key={dataElement.id}
                    user={{ user: dataElement.user }}
                    group={group}
                    rightPlacement={false}
                  />
                </div>
              )
            })}
          </>
          :
          <h1 className={`${styles.contentSelector__noResults}`}>No results found</h1>

      }
    </PerfectScrollbar>
  )
}

export default TeammateSelector